export enum EnergyMedium {
  ELECTRIC = 'electric',
  GAS = 'gas',
  AIR = 'air',
  CO2 = 'co2',
  OXYGEN = 'oxygen',
  ARGON = 'argon',
}

export const energyOptions = [
  { key: EnergyMedium.ELECTRIC, label: '电', mediumType: 0 },
  { key: EnergyMedium.GAS, label: '天然气', mediumType: 1 },
  { key: EnergyMedium.AIR, label: '压缩空气', mediumType: 2 },
  { key: EnergyMedium.CO2, label: '二氧化碳', mediumType: 3 },
  { key: EnergyMedium.OXYGEN, label: '氧气', mediumType: 4 },
  { key: EnergyMedium.ARGON, label: '氩气', mediumType: 5 },
];

export const electricTabs = [
  { key: 'station', label: '站房' },
  { key: 'line', label: '线路' },
];

export const gasTabs = [
  { key: 'plant', label: '全厂' },
  { key: 'station', label: '站房' },
  { key: 'outlet', label: '出口' },
  { key: 'area', label: '区域' },
];

export const compressorTab = { key: 'compressor', label: '空压机' };

export const ranges = [
  { key: 'low', label: '0~60%', cardLabel: '负载率: 0~60%', color: '#16d998', countField: 'lowCount' },
  { key: 'mid', label: '60~80%', cardLabel: '负载率: 60~80%', color: '#f0c748', countField: 'midCount' },
  { key: 'high', label: '80~100%', cardLabel: '负载率: 80~100%', color: '#ff8b3d', countField: 'highCount' },
  { key: 'over', label: '100%以上', cardLabel: '负载率: 100%以上', color: '#ff4d5b', countField: 'overCount' },
];

export const dimensionUnitMap: Record<string, string> = {
  line: '回路',
  station: '站房',
  outlet: '出口点位',
  area: '区域',
  compressor: '空压机',
};

export const rateOperatorOptions = ['>', '>=', '<', '<='].map(item => ({ label: item, value: item }));
